import React from 'react';
import classnames from 'classnames';

import styles from './styles.module.scss';

const Box = ({ image, title, onClickEvent, selected }) => {
  const styleImage = { backgroundImage: `url(${image})` };
  return (
    <div
      className={classnames(styles.boxWrapper, selected && styles.selected)}
      onClick={onClickEvent}>
      {selected && (
        <div className={styles.iconWrapper}>
          <i className={classnames('material-icons', styles.materialIcons)}>
            done
          </i>
        </div>
      )}
      <div className={styles.boxContent}>
        {image && <div className={styles.image} style={styleImage} />}
        {title}
      </div>
    </div>
  );
};

export default Box;
